const initialStatus = {
  loading: false,
  success: false,
  error: false,
  data: null,
  message: null,
}

const initialState = { list: [], conversations: {} }

const widgetReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'RESET_WIDGETS_OBJ':
      return {}
    case 'RESET_WIDGETS_STATUS':
      return {
        ...state,
        status: {
          ...state.status,
          [action.payload]: initialStatus,
        },
      }
    case 'WIDGETS_ERROR':
      return {
        ...state,
        status: {
          ...state?.status,
          [action?.payload?.action]: {
            ...initialStatus,
            error: true,
            message: action?.payload?.message,
          },
        },
      }
    case 'GET_WIDGETS':
      return {
        ...state,
        status: {
          get_widgets: {
            ...initialStatus,
            loading: true,
            data: { ...action.payload },
          },
        },
      }
    case 'SET_WIDGETS':
      return {
        ...state,
        list: [...action.payload],
        status: {
          get_widgets: {
            ...initialStatus,
            success: true,
          },
        },
      }
    case 'GET_WIDGET':
      return {
        ...state,
        status: {
          get_widget: {
            ...initialStatus,
            loading: true,
            data: { ...action.payload },
          },
        },
      }
    case 'SET_WIDGET': {
      const data = action.payload.data
      const chatId = action.payload.chatId
      const widgetId = action.payload.widgetId
      const widgetName = action.payload.widgetName
      const widgetType = action.payload.widgetType
      const widgets = (chatId && state.conversations?.[chatId]) ?? []
      const obj = { id: widgetId, name: widgetName, widgetType, data }

      // Find widget to be updated
      const index = widgets.findIndex((e) => e.id === widgetId)
      if (index >= 0) widgets[index] = obj
      else widgets.push(obj)

      return {
        ...state,
        conversations: {
          ...state.conversations,
          [chatId]: widgets,
        },
        status: {
          ...state.status,
          get_widget: {
            ...initialStatus,
            success: true,
          },
        },
      }
    }
    case 'DELETE_WIDGET':
      const conversationId = action.payload
      const { [conversationId]: chatDeleted, ...newChats } = state.conversations
      return {
        ...state,
        conversations: newChats,
      }

    default:
      return state
  }
}

export default widgetReducer
